export default {
	required: "This field is required",
	email: "Invalid email format",
	minLength: "The {field} field must have at least {min} characters",
	maxLength: "The field must have at most {max} characters",
	passwordMismatch: "Passwords do not match",
	requiredField: "The {field} field is required",
	cpfDigits: "CPF must have 11 digits",
	cpfInvalid: "Invalid CPF — check the numbers",
	zipCodeDigits: "Postal code must have 8 digits",
	invalidPhone: "Invalid phone number",
};
